<template>
    <Layout>
        <PageHeader :title="$t('module.meetingRoom')" :items="breadcrumbs" />
        <div class="card">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-lg-4 mb-2 mb-lg-0">
                        <b-input-group>
                            <b-form-input v-model.trim="searchText" type="search" :placeholder="$t('label.search')"
                                autocomplete="off" @keyup.enter="search" />
                            <b-input-group-append>
                                <b-button variant="info" @click="search">
                                    <i class="mdi mdi-magnify"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                    <div class="col-lg-8 d-flex justify-content-lg-end">
                        <b-button variant="info" @click="open()">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ $t('label.createX', [$t('module.meetingRoom')]) }}
                        </b-button>
                    </div>
                </div>
                <div v-if="!status.list" class="text-center p-5">
                    <b-spinner variant="info" />
                </div>
                <template v-else>
                    <b-table :items="rows" :fields="fields" show-empty responsive no-local-sorting
                        @sort-changed="sort"><template #cell(imageUrl)="{ item }"><img v-if="item.imageUrl"
                                :src="item.imageUrl" :alt="item.name" class="room-image">
                            <span v-else>-</span>
                        </template>
                        <template #cell(isMuslimFriendly)="{ item }">
                            {{ $t(item.isMuslimFriendly ? 'label.yes' : 'label.no') }}
                        </template>
                        <template #cell(isServeDeck)="{ item }">
                            {{ $t(item.isServeDeck ? 'label.yes' : 'label.no') }}
                        </template>
                        <template #cell(isActive)="{ item }">
                            <b-form-checkbox :checked="item.isActive" switch :disabled="!status.save"
                                @change="changeStatus(item, $event)">{{ item.isActive ? $t('label.active') :
                                    $t('label.inactive') }}</b-form-checkbox>
                        </template>
                        <template #cell(actions)="{ item }">
                            <a href="javascript:void(0)" class="text-info" @click="open(item)">
                                <i class="mdi mdi-pencil-outline font-size-18"></i>
                            </a>
                            <a href="javascript:void(0)" class="text-danger ml-2" @click="remove(item)">
                                <i class="mdi mdi-delete-outline font-size-18"></i>
                            </a>
                        </template>
                    </b-table>
                    <div v-if="pagination.total" class="d-flex justify-content-between align-items-center mt-3">
                        <small>
                            {{ $tc('label.results', pagination.total, [pagination.total]) }}
                        </small>
                        <b-pagination v-model="page" :total-rows="pagination.total" :per-page="filter.pageSize"
                            class="mb-0" @change="go" />
                    </div>
                </template>
            </div>
        </div>
        <b-modal id="meeting-room-form"
            :title="$t(selectedUUID ? 'label.updateX' : 'label.createX', [$t('module.meetingRoom')])" size="xl"
            hide-footer hide-header-close centered @hidden="close">
            <MeetingRoomForm v-if="visible" :meeting-room-u-u-i-d="selectedUUID" :search-criteria="filter"
                @done="close" />
        </b-modal>
    </Layout>
</template>

<script>
import { mapState } from 'vuex'; import Layout from '@/views/layouts/main'; import PageHeader from '@/components/page-header'; import i18n from '@/i18n'; import { meetingRoomMethods } from '@/state/api'; import { MEETING_ROOM_MODULE } from '@/state/api/meetingRoom.state'; import MeetingRoomForm from './form';
const defaults = () => ({
    pageNumber: 1,
    pageSize: 15,
    searchArray: [],
    sortBy: 'created_at',
    orderBy: 'desc'
});
export default {
    name: 'MeetingRoomListing',
    page: { title: i18n.t('module.meetingRoom') },
    components: { Layout, PageHeader, MeetingRoomForm },
    data() {
        return {
            searchText: '',
            page: 1,
            filter: defaults(),
            visible: false,
            selectedUUID: '',
            breadcrumbs: [{ text: i18n.t('module.meetingRoomManagement'), href: '/meeting-room-management' }, { text: i18n.t('module.meetingRoom'), active: true }],
            fields: [
                { key: 'imageUrl', label: i18n.t('label.image') },
                { key: 'name', label: i18n.t('label.name'), sortable: true },
                { key: 'officeName', label: i18n.t('label.office') },
                { key: 'capacity', label: i18n.t('label.capacity') },
                { key: 'isMuslimFriendly', label: i18n.t('label.muslimFriendly') },
                { key: 'isServeDeck', label: "Serve Deck" },
                { key: 'isActive', label: i18n.t('label.status') },
                { key: 'actions', label: i18n.t('label.action') }]
        };
    },
    computed: {
        ...mapState(MEETING_ROOM_MODULE, ['status']),
        rows() {
            return this.$store.state.api.meetingRoom.list.data || [];
        },
        pagination() {
            return this.$store.state.api.meetingRoom.list.pagination || {};
        }
    },
    created() {
        this.load();
    },
    methods: {
        ...meetingRoomMethods,
        load() {
            return this.getAllMeetingRoom({ filter: this.filter });
        },
        search() {
            this.page = 1;
            this.filter = {
                ...this.filter,
                pageNumber: 1,
                searchArray: this.searchText ? [this.searchText] : []
            };
            this.load();
        },
        go(pageNumber) {
            this.page = pageNumber;
            this.filter = { ...this.filter, pageNumber };
            this.load();
        },
        sort({ sortBy, sortDesc }) {
            const fields = { code: 'code', name: 'name' };
            if (!fields[sortBy]) return;
            this.page = 1;
            this.filter = {
                ...this.filter,
                pageNumber: 1,
                sortBy: fields[sortBy],
                orderBy: sortDesc ? 'desc' : 'asc'
            }; this.load();
        },
        open(item = null) {
            this.selectedUUID = item?.uuid || '';
            this.visible = true;
            this.$nextTick(() => this.$bvModal.show('meeting-room-form'));
        },
        close() {
            this.$bvModal.hide('meeting-room-form');
            this.visible = false; this.selectedUUID = '';
        },
        async changeStatus(item, isActive) {
            const ok = await this.$bvModal.msgBoxConfirm(this.$t('label.confirmChangeStatusX', [isActive ? this.$t('label.activate') : this.$t('label.deactivate'), item.name]), { title: this.$t('label.confirmStatusChange'), centered: true }); if (ok) await this.updateMeetingRoomStatus({ uuid: item.uuid, isActive, filter: this.filter }); else await this.load();
        },
        async remove(item) {
            const ok = await this.$bvModal.msgBoxConfirm(this.$t('label.confirmDeleteX', [item.name]), { title: this.$t('label.confirmDelete'), okTitle: this.$t('label.delete'), okVariant: 'danger', centered: true });
            if (ok) {
                await this.deleteMeetingRoom({ uuid: item.uuid, filter: this.filter });
            }
        }
    }
};
</script>
<style scoped>
.room-image {
    width: 56px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px
}
</style>
